import BasePropertyView from 'BasePropertyView.js';
import {Model}          from 'backbone';
import template         from 'common-views/properties/select-value.ejs'
import _                from 'lodash';
import $                from 'jquery';
import listService      from 'ListService.js';
import undoService      from 'UndoService.js';
import selectFieldModal from 'common-views/SelectFieldModalView';
import formulaModal     from 'common-views/MainFormulaModalView.js';
import specialFormList  from 'SpecialFormList.js';
import widgetUtil       from 'util/WidgetUtil.js';
import util from 'util/Util.js';
class SelectValuePropertyView extends BasePropertyView {
    initialize(opts){
        this.viewTitle = _.get(opts, 'config.viewTitle') || 'Select Value';
        this.modelField = opts.config.modelField || 'default';
        this.fieldDisplayName = _.get(opts, 'config.fieldDisplayName') || 'selectedFieldName';

        this.model.set('PropId', this.modelField, {silent:true});
        this.model.set('fieldDisplayName', this.fieldDisplayName, {silent:true});

        //PF-6666 If it has fieldName check to ensure the field still exists
        if(this.model.get("fieldName") && this.model.get("selectedFieldId")){
            const fieldName = listService.determineFieldName(this.model.get("selectedFieldId"));
            this.model.set('fieldName', fieldName, {silent:true});
        }
        
        if (!this.model.attributes.Parameters) {
            this.model.attributes.Parameters = {};

            let Parameter = { id: this.modelField, type: 'literal', literal: '', field: 'null', special: 'stage'};

            this.model.attributes.Parameters.Parameter = [Parameter];
        }
        
        let parmTest = this.getParameter();
        if (!parmTest) {
            let Parameter = { id: this.modelField, type: 'literal', literal: '', field: 'null', special: 'stage'};
            this.model.attributes.Parameters.Parameter.push(Parameter);
        }

        // Set Fieldname on incoming from Server
        const parameter = this.getParameter();
        if (parameter.type === 'field') {
            const id = parameter.field;
            const objName = listService.determineFieldName(id);
            this.model.set(this.fieldDisplayName, objName, {silent: true});
            this.model.set("selectedFieldId", id, {silent: true});
        }
        
        this.model.set('specialInstance', specialFormList.getSpecialFormList(), {silent:true} );

        //this.validateModel();
        this.registerEvents();

    }

    getParameter() {
        let self = this;
        const prop = this.model.get('Parameters');
        const parameter = _.find(prop.Parameter, function(obj) { return obj.id === self.modelField });
        return parameter;
    }

    registerEvents(){
        this.events = {
            'click .valueType'              : 'changeType',
            'click #ValueOfAFieldButton'    : 'showValueFieldModal',
            'change #specialValue'          : 'selectSpecialValue',
            'change #TextOrNumber'          : 'selectTextOrNumberValue',
            'click #Formula'                : 'showFormulaModal',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };
        this.listenTo(this.model, 'change', this.render);
    }

    validateModel(){
        if(!this.model.has(this.modelField) || typeof this.model.get(this.modelField) !== 'object'){
            /**
             * On the xml, the value selected by this modal is an object with 4 properties
             * type, literal, field and special. When the type = formula, the xml stores a formula
             * object as a child for this object.
             */
            this.model.set(this.modelField, {type:"", literal:"", field:"", special:""}, {silent:true});
        }
        if (!this.model.get(this.fieldDisplayName)) {
            this.model.set(this.fieldDisplayName, '', {silent: true});
        }
    }

    showFormulaModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';
        let  attributes = {};

        let self = this;
        const parameter = this.getParameter();
        const oldExpression=Object.assign({},parameter.Expression);
        attributes = {formulaParameter: parameter.Expression };



        let sfModal = new formulaModal({model: new Model(attributes), config: {selected: ''}});
        sfModal.render().then((formulaParameter)=>{
            parameter.Expression = formulaParameter;
            // PF-2041 Tracking Expression on the model being placed on the modal.
            this.model.trigger('widgetTextUpdated');
            this.render();
            this.recalculateWidgetText();
            const updatedExpression=Object.assign({},parameter.Expression);
            undoService.add({
                undo:() =>{
                    const undoParameter=self.getParameter();
                    undoParameter.Expression = oldExpression;
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                    self.recalculateWidgetText();
                },
                redo:() =>{
                    const redoParameter=self.getParameter();
                    redoParameter.Expression = updatedExpression;
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                    self.recalculateWidgetText();
                }
            },"Value Property");
            self.model.trigger('change');
        }).catch(err => {
            console.log(err)
        });
    }

    getViewValues(){
        const parameter = this.getParameter();
        return _.merge(this.model.attributes, {viewTitle: this.viewTitle, fieldName: this.model.get('fieldName') || this.model.get(this.fieldDisplayName) || '', textOrNumberValue: parameter.literal} );
    }

    enableValueType(selectedType){
        const valueSelects = this.$el.find('.valueSelect');

        valueSelects.map((index, button) => {
            let buttonValueType = button.getAttribute('data-value-type');
            if( buttonValueType !== selectedType){
                button.setAttribute('disabled', 'disabled');
            } else {
                button.removeAttribute('disabled');
            }

        });
    }

    checkSelectedType(selectedType){
        const valueTypes = this.$el.find('.valueType');

        valueTypes.map((index, input) => {
            let inputValueType = input.value;
            if( inputValueType === selectedType){
                input.setAttribute('checked', 'checked');
            } else {
                input.removeAttribute('checked');
            }

        });
    }

    changeType(e){
        this.selectType(e.currentTarget.value);
    }

    selectType(type){
        const parameter = this.getParameter();
        const oldParameterType = parameter.type;
        parameter.type = type;

        this.model.trigger('widgetTextUpdated');
        this.render();
        this.recalculateWidgetText();
        const updatedParameterType = parameter.type;

        undoService.add({
            undo:() => {
                const parameter = this.getParameter();
                parameter.type = oldParameterType;
                this.model.trigger('widgetTextUpdated');
                this.render();
                this.recalculateWidgetText();
            },
            redo:() => {
                const parameter = this.getParameter();
                parameter.type = updatedParameterType;
                this.model.trigger('widgetTextUpdated');
                this.render();
                this.recalculateWidgetText();
            }
        },'Value Property')
    }

    getValueObject(){
        return this.model.get(this.modelField);
    }

    showValueFieldModal(ev) {
        ev.preventDefault();
        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.get("selectedFieldId"), {silent:true});
        let sfModal = new selectFieldModal({model: sfModel});
        let self = this;

        sfModal.render().then((selectedField)=>{
            let oldSelectedFieldName=self.model.get(self.fieldDisplayName);
            let oldField=self.model.get('field');

            // used only for display in the UI
            if(self.fieldDisplayName ==='selectedFieldName'){
                self.model.set('fieldName',selectedField.name,{silent:true});
            }
            self.model.set(self.fieldDisplayName, selectedField.name, {silent: true});
            self.model.set('fieldDisplayName', self.fieldDisplayName, {silent:true});

            const parameter = self.getParameter();
            const oldParameterField=parameter.field;
            parameter.field = selectedField.id;

            self.model.set("selectedFieldId", selectedField.id, {silent:true})

            self.selectValue('field', selectedField.id);
            self.model.trigger('change');
        }, emsg => console.log(emsg)).catch(emsg => {
            console.log(emsg);
        });

        undoService.add({
            undo:() => {
                if(this.fieldDisplayName ==='selectedFieldName'){
                    this.model.set('fieldName',oldSelectedFieldName,{silent:true});
                }
                this.model.set(this.fieldDisplayName, oldField, {silent: true});
                const undoParameter = this.getParameter();
                undoParameter.field=oldParameterField;

                this.selectValue('field',oldParameterField);
            },
            redo:() => {
                if(this.fieldDisplayName ==='selectedFieldName'){
                    this.model.set('fieldName',selectedField.name,{silent:true});
                }
                this.model.set(this.fieldDisplayName, selectedField.name, {silent: true});
                const redoParameter = this.getParameter();
                redoParameter.field=selectedField.id;

                this.selectValue('field',selectedField.id);
            }
        },'Value Property');

    }

    selectSpecialValue(e){
        const
            target = e.currentTarget,
            selectedValue = target.value;
        this.selectValue('special', selectedValue);

        const oldParameterLiteral=this.getParameter()['special'];

        undoService.add({
            undo:() => {
                this.selectValue('special',oldParameterLiteral);
            },
            redo:() => {
                this.selectValue('special',selectedValue);
            }
        },"Value Property")
    }

    selectTextOrNumberValue(e){
        const
            target = e.currentTarget,
            selectedValue = util.sanitizeHTML(target.value, true, this.getParameter()['literal']);
        const oldParameterLiteral=this.getParameter()['literal'];
        const factoryKey = this.model.get('factoryKey');
        if (factoryKey === 'command_show_message' || factoryKey === 'command_show_url'){
            const parameter = this.getParameter();
            parameter['literal'] = selectedValue;
            this.model.set({ 'widgetText': widgetUtil.getWidgetText(this.model) },{silent:true});
            //PF-4035 Timeout for edge to about conflicts with the events and about killing the browser
            setTimeout(() => {
                this.model.trigger('widgetTextUpdated');
            }, 10);
        }else{
            this.selectValue('literal', selectedValue);
        }
       

        undoService.add({
            undo:() => {
                this.selectValue('literal',oldParameterLiteral);
            },
            redo:() => {
                this.selectValue('literal',selectedValue);
            }
        },"Value Property ")
    }

    selectValue(selectedType, selectedValue){
        const parameter = this.getParameter();
        parameter[selectedType] = selectedValue;
        this.model.trigger('widgetTextUpdated');
        this.render();
        this.recalculateWidgetText();
    }

    recalculateWidgetText(){
        const factoryKey = this.model.get('factoryKey');
        if (factoryKey === 'command_show_message' || factoryKey === 'command_show_url'){
            this.model.set({ 'widgetText': widgetUtil.getWidgetText(this.model) },{silent:true});
            this.model.trigger('widgetTextUpdated');
            this.render();
         }
    }

    render(){
        this.$el.html(template(this.getViewValues()));
        const parameter = this.getParameter();
        this.enableValueType(parameter.type);
        this.checkSelectedType(parameter.type);

        $('#' + this.modelField + ' #specialValue').find('option[value="' + parameter.special + '"]').attr('selected', true);

        this.delegateEvents();

    }

}

export default SelectValuePropertyView;